var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"progress-icon-wrapper"},[(_vm.loadingCaption)?_c('span',[_vm._v("\n      "+_vm._s(_vm.loadingCaption)+"\n    ")]):_vm._e(),_c('div',{staticClass:"progress-icon"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }